import { render, staticRenderFns } from "./Jahresabschlussbewertung.vue?vue&type=template&id=dc3c0ea4&"
import script from "./Jahresabschlussbewertung.vue?vue&type=script&lang=js&"
export * from "./Jahresabschlussbewertung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports